import type { FaireProductEntity } from "../../entity_types/product";

export const p_dffzmbdqvq: FaireProductEntity = {
  token: "p_dffzmbdqvq",
  type: "product",
  name: "LM-SK-1000 BUBBLE SKIRT - LAVENDER",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/f0700e068680d5fb0825e225621139b50680d1614d293fc0c7c059c416e8bee6.jpeg",
  galleryImageUrls: [],
  priceDollars: 18.5,
  description: "This bubble skirt from Girlie Girl Originals features a lavender hue and a playful bubble silhouette. It pairs with tops or blouses for versatile styling and adds a feminine touch to wardrobes. Brand: Girlie Girl Originals — stylish, bold apparel with southern flair for boutiques and retailers. Please contact us for our MAP policy.",
  tags: [],
  msrpDollars: 37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:34.101Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
